// Reusable frontend-only project data
// Accurately reflects Vivek Carpenter's real-world MERN & frontend engineering experience

export const projects = [
  {
    id: 1,
    title: "Pet Medical Software — Veterinary Management Platform",
    category: "Full Stack",
    company: "Krishaa Soft IT Solutions",
    date: "Jan 2026 – Present",
    description:
      "A production-grade full-stack veterinary clinical management platform designed to manage patient health records, diagnosis tracking, dynamic prescription generation, automated PDF reports, dynamic medical forms, and clinical analytics.",
    technologies: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redux Toolkit",
      "RTK Query",
      "JWT & RBAC",
      "AI API Integration",
      "PDF Generation"
    ],
    image:
      "https://images.unsplash.com/photo-1576201836106-db1758fd1c97?auto=format&fit=crop&w=1200&q=80",
    github: "https://github.com/vivekcarpenter",
    webapp: "https://studynotion-frontend-theta-sepia.vercel.app/",
    featured: true,
    highlights: [
      "Built secure REST APIs with JWT authentication and Role-Based Access Control (RBAC) for doctors and clinic staff",
      "Implemented Redux Toolkit and RTK Query for state management, optimistic UI updates, and intelligent API caching",
      "Integrated AI-powered diagnostic summaries, dynamic medical form builders, and multi-file document uploads",
      "Engineered client-side and server-side PDF report generation for digital prescriptions and laboratory tests"
    ]
  },
  {
    id: 2,
    title: "Ariqua — Full-Stack E-Commerce Platform",
    category: "Full Stack",
    company: "Krishaa Soft IT Solutions",
    date: "Jan 2026 – Present",
    description:
      "A complete scalable e-commerce platform featuring catalog browsing, cart operations, multi-step checkout, user authentication, order lifecycle tracking, and an administrative back-office management console.",
    technologies: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redux Toolkit",
      "RTK Query",
      "Docker",
      "Hostinger VPS",
      "Cloud Storage"
    ],
    image:
      "https://images.unsplash.com/photo-1557821552-17105176677c?auto=format&fit=crop&w=1200&q=80",
    github: "https://github.com/vivekcarpenter",
    webapp: "https://asiaestate.onrender.com/",
    featured: true,
    highlights: [
      "Engineered full product, category, cart, order, and checkout workflows with synchronized backend inventory",
      "Integrated Redux Toolkit and RTK Query for caching and instantaneous frontend-backend data synchronization",
      "Configured Dockerized microservice architecture and managed production deployment on Hostinger VPS",
      "Implemented cloud media storage, strict validation pipelines, and secure payment / order confirmation flows"
    ]
  },
  {
    id: 3,
    title: "Asia Estate — Real Estate Marketplace",
    category: "Full Stack",
    date: "2024 – 2025",
    description:
      "A full-stack real estate discovery and listing platform allowing users to explore, filter, rent, and purchase residential and commercial estates with transparent pricing and cloud media galleries.",
    technologies: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redux",
      "JWT Auth",
      "Firebase Storage",
      "Tailwind CSS"
    ],
    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80",
    fallbackImage:
      "https://firebasestorage.googleapis.com/v0/b/asia-estate.appspot.com/o/home2.jpeg?alt=media&token=27b9fdf4-3b57-49d8-95a8-e851dea92ead",
    github: "https://github.com/Vivek15Pro/AsiaEstate",
    webapp: "https://asiaestate.onrender.com/",
    featured: true,
    highlights: [
      "JWT session authentication and Google OAuth integration",
      "Real-time search filters by pricing, location, property type, and amenities",
      "Multi-image cloud uploads with optimized thumbnail previews and responsive modal views",
      "Clean REST API architecture with modular controllers, models, and middleware"
    ]
  },
  {
    id: 4,
    title: "Study Notion — EdTech Course Management Platform",
    category: "Full Stack",
    date: "2024",
    description:
      "A comprehensive educational technology portal providing structured course catalog management, student progress dashboards, instructor analytics, and automated notification dispatches.",
    technologies: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redux Toolkit",
      "Tailwind CSS",
      "RESTful API"
    ],
    image:
      "https://images.unsplash.com/photo-1501504905252-473c47e087f8?auto=format&fit=crop&w=1200&q=80",
    fallbackImage:
      "https://assets.devfolio.co/hackathons/633065500193427091033d2cfc2621e6/projects/8e80723867854f33939a9dd0170f0927/de9fdc7c-ae37-4eb7-a0d1-d79f20203462.png",
    github: "https://github.com/vivekcarpenter/studynotion-frontend",
    webapp: "https://studynotion-frontend-theta-sepia.vercel.app/",
    featured: false,
    highlights: [
      "Instructor dashboard for course curriculum authoring and media management",
      "Student learning portal with lesson navigation, notes, and progress tracking",
      "Responsive user interface styled with modern Tailwind CSS utilities",
      "State management powered by Redux Toolkit for clean state flow"
    ]
  },
  {
    id: 5,
    title: "CryptoVerse 3D — Financial Market Visualizer",
    category: "React & 3D",
    date: "2024",
    description:
      "An interactive WebGL-powered financial market terminal combining Three.js 3D assets, live cryptocurrency market price feeds, historical candlestick trend charts, and real-time statistics.",
    technologies: [
      "React.js",
      "Three.js",
      "React Three Fiber",
      "Tailwind CSS",
      "REST APIs",
      "Chart.js"
    ],
    image:
      "https://images.unsplash.com/photo-1621416894569-0f39ed31d247?auto=format&fit=crop&w=1200&q=80",
    github: "https://github.com/vivekcarpenter",
    webapp: "https://asiaestate.onrender.com/",
    featured: false,
    highlights: [
      "Interactive 3D cryptocurrency assets rendered in real-time WebGL with smooth mouse tracking",
      "Live market price updates integrated via external cryptocurrency endpoints",
      "Interactive historical price charts with timeframe toggles (24h, 7d, 30d, 1y)",
      "Clean dark theme glassmorphism UI optimized for high-density information displays"
    ]
  },
  {
    id: 6,
    title: "DevConnect — Developer Collaboration Portal",
    category: "Full Stack",
    date: "2024",
    description:
      "A developer social ecosystem featuring technical portfolio showcases, code snippet discussions, real-time repository feeds via GitHub API, and clean developer profiles.",
    technologies: [
      "React 18",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Redux",
      "GitHub REST API"
    ],
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80",
    github: "https://github.com/vivekcarpenter",
    webapp: "https://asiaestate.onrender.com/",
    featured: false,
    highlights: [
      "Live synchronization with official GitHub API for public repositories and recent commits",
      "Markdown code editor with live syntax highlighting and snippet sharing",
      "Role-based profile personalization with bio, tech stack badges, and project links",
      "Modular full-stack MERN codebase structured for maintainability"
    ]
  }
];

export default projects;
